import styled from 'styled-components';

const Card = styled.div`
  border-radius: 20px;
  background-color: transparent;
  padding: 20px;
  row-gap: 10px;
  border: 1px solid var(--border-muted);
  background: var(--elevation-high);
  box-sizing: border-box;

  display: flex;
  flex-direction: column;

  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};

  ${({ $selected, $clickable }) =>
    !$selected &&
    $clickable &&
    `
    &:hover {
      background-color: var(--elevation-indented);
    };
  `}

  ${({ $selected, $clickable }) => {
    if ($selected) {
      return `
        box-shadow: 0 18px 36px 0 var(--gray-8), 0 10px 20px 0 var(--gray-6), 0 3px 6px 0 var(--gray-4);
        background-color: var(--elevation-mid);
      `;
    }

    if ($clickable) {
      return `
        cursor: pointer;
      `;
    }

    return null;
  }}
`;

export { Card };
